import { BusinessLevel } from '../../../business-level/business-level';
import { BusinessStatus } from '../../../constants/business-status';
import { Region } from '../../region/region';
import { Country } from '../country/country';
import { RepresentativeSummaryResponseDTO } from '../representative-summary-response-dto/representative-summary-response-dto';

/**
 * Business Summary Response DTO used to interact with backend
 */
export class BusinessSummaryResponseDTO {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public id: number,
    public status: BusinessStatus,
    public registerDate: Date,
    public picture?: string,
    public name?: string,
    public address?: string,
    public postalCode?: string,
    public addressNumber?: string,
    public state?: string,
    public region?: Region,
    public country?: Country,
    public email?: string,
    public businessType?: string,
    public businessLevel?: BusinessLevel,
    public businessLevels?: BusinessLevel[],
    public activeBusinessLevels?: BusinessLevel[],
    public nextBusinessLevels?: BusinessLevel[],
    public website?: string,
    public representatives?: RepresentativeSummaryResponseDTO[],
    public nextBusinessLevel?: BusinessLevel,
    public phoneNumber?: string,
    public disabledAt?: string,
    public active?: boolean
  ) {}
}
